import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { Caddy } from '../../model/caddy.model';
import { ArticleModel } from '../../model/article.model';
import { AskQuestionModel, langAndCaddy } from '../../model/chat.model';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { embedClient } from '../../model/leader-board.model';
import { BackButton, BackButtonAction } from '../../model/shared.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  loading = signal<boolean>(true);
  loggedIn = signal<boolean>(false);
  userSettingsLoaded = signal<boolean>(false);
  openDiscoverSettings = signal(false);
  embedClient = signal<embedClient>(new embedClient());
  gpsSignal = signal<{ latitude: number | null, longitude: number | null }>({ latitude: null, longitude: null });
  backButton = signal<BackButton>(new BackButton());
  backButtonAction = signal<BackButtonAction>(new BackButtonAction());

  verificationToken = signal<string>('');
  selectedCaddyAndLanguage = signal<langAndCaddy>(new langAndCaddy());

  private questionData = new BehaviorSubject<any>('');
  question = this.questionData.asObservable();

  private userData = new BehaviorSubject<User>(new User());
  user$ = this.userData.asObservable();

  private openLoginModal = new BehaviorSubject<{status: boolean, window: string}>({status: false, window: 'login'});
  openLoginModal$ = this.openLoginModal.asObservable();
  // private articleData: BehaviorSubject<ArticleModel> = new BehaviorSubject<ArticleModel>(new ArticleModel());
  // public articleData$: Observable<ArticleModel> = this.articleData.asObservable();

  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();
  private isMyBagActive:  BehaviorSubject<string> = new BehaviorSubject<string>("");
  public isMyBagActive$: Observable<string> = this.isMyBagActive.asObservable();
  constructor( 
    @Inject(PLATFORM_ID) private platformId: Object,
    private _httpClient: HttpClient
   ) {
    }

  setQuestion(data: AskQuestionModel): void {
    this.questionData.next(data);
  }

  setUserImage(image: string): void {
    const currentUser = this.userData.value;  // Get the current value of userData
    const updatedUser = { ...currentUser, imageUrl: image };  // Create a new user object with updated image
    this.userData.next(updatedUser);  // Update the BehaviorSubject
  }

  setUser(data: User): void {
    this.userData.next(data);
  }

  open(data: User): void {
    this.userData.next(data);
  }

  openAuthModal(status: boolean, window = 'login'): void {
    this.openLoginModal.next({status, window});
  }
  // setArticleData(article: ArticleModel) {
  //   this.articleData.next(article);
  // }
  setPreviousUrl(url: string){
    this.previousUrl.next(url);
  }

  setLocalStorage(key: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }

  getLocalStorage(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
    return '';
  }

  removeFromLocalStorage(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.removeItem(key);
    }
    return '';
  }


  clearLocalStorage(){
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
  setByBagSettingTab(tabName: string){
    this.isMyBagActive.next(tabName);
  }

  golfTap() {
    this.golfTapRegister().subscribe({
      next: (res) => {
        console.log('Golf Tap registered successfully', res);
      }})
    localStorage.clear();
    localStorage.setItem('golfTap', 'true'); // Store flag
    document.body.innerHTML = `
      <div style="text-align: center; margin-top: 20%; font-size: 24px; color: red;">
        <p>⚠️ WARNING: Unauthorized Activity Detected! ⚠️</p>
        <p>System Lockdown in <span id="countdown">5</span> seconds...</p>
      </div>`;
  }

  golfTapRegister() {
    return this._httpClient.get(`https://golfai.dev/api/user-log/click/register`); 
  }
}
